import React, { useState, useEffect } from 'react';

import LabelList from './LabelList';
import LabelInformation from './LabelInformation';
import './LabelManagerMain.css'

const LabelManagerMain = (props) => {
  // const [userLabelData, setUserLabelData] = useState([]);
  // const [selectedLabelData, setSelectedLabelData] = useState([]);

  // useEffect(() => {
  //   setUserLabelData(props.userLabelData)
  // }, [props.userLabelData])

  // useEffect(() => {
  //   setSelectedLabelData(props.selectedLabelData);
  // }, [props.selectedLabelData])


  return (
    <div className="row featured-main">
      <div className="manageReportBoxLR">
        <table width="100%" border="0" cellspacing="0" cellpadding="0">
          <tr>
            <td width="22%" valign="top">
              <div id="manageReportLeft">
                <LabelList labelData={props.userLabelData} createLabel={props.createLabel} handleLabelListClick={props.handleLabelListClick} handleCreateInput={props.handleCreateInput} createLabelName={props.createLabelName} />
              </div>
            </td>
            <td width="78%" valign="top">
              <div id="manageReportRight">
                <LabelInformation selectTargetLabel={props.selectTargetLabel} targetLabelSelectOption={props.targetLabelSelectOption} selectedLabelData={props.selectedLabelData} userLabelData={props.userLabelData}
                  handleChangeLabelNameInput={props.handleChangeLabelNameInput} handleNameChangeShow={props.handleNameChangeShow} handleNameChangeClose={props.handleNameChangeClose} nameChangeShow={props.nameChangeShow} changeLabelName={props.changeLabelName}
                  handleChangeLabelName={props.handleChangeLabelName} handleCheckBox={props.handleCheckBox} handleMoveItem={props.handleMoveItem} handleRemoveItem={props.handleRemoveItem} handleRemoveLabel={props.handleRemoveLabel}
                />
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  )
}

export default LabelManagerMain;